import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import useEvent from "../../hooks/useEvent.hook";
import useSeats from "../../hooks/useSeats.hook";
import VenueSeatingChart from "../VenueSeatingChart";
import * as EventActions from "../../redux/actions/event.actions";

const Container = styled.div`
  position: relative;
`;

type CreateEventSeatingChartProps = {};

const CreateEventSeatingChart: React.FC<CreateEventSeatingChartProps> = () => {
  /* Hooks */
  const { event, eventId } = useEvent();
  const { client } = useSeats();
  const dispatch = useDispatch();

  /* State */
  const [chart, setChart] = React.useState(null);

  /* Actions */
  React.useEffect(() => {
    const fetchData = async () => {
      if (client && event?.seatingChartKey) {
        setChart(null);
        let chart = await client.charts.retrieve(event?.seatingChartKey);
        chart.categories = await client.chartReports.byCategoryLabel(chart.key);
        setChart(chart);

        // If event has no orders yet, automatically sync category capacities into Redux
        if (!event?.hasOrders && chart.categories) {
          dispatch(EventActions.setEventSeatingChartFields(eventId, chart.categories));
        }
      }
    };
    fetchData();
  }, [client, event?.seatingChartKey, event?.hasOrders]);

  /** Render */
  if (!event?.seatingChartKey) return null;

  return (
    <Container>
      <VenueSeatingChart chart={chart} showActions={false} margin="10px 0" />
    </Container>
  );
};

export default CreateEventSeatingChart;
